import { render, staticRenderFns } from "./Peajes.vue?vue&type=template&id=ed254406&scoped=true&"
import script from "./Peajes.vue?vue&type=script&lang=ts&"
export * from "./Peajes.vue?vue&type=script&lang=ts&"
import style0 from "./Peajes.vue?vue&type=style&index=0&id=ed254406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed254406",
  null
  
)

export default component.exports